export default function () {
    const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    };
    // Detects if device is in standalone mode
    const isInStandaloneMode = () =>
        "standalone" in window.navigator &&
        (window.navigator as any).standalone;

    // Checks if should display install popup notification:
    const showInstallMessage = isIos() && !isInStandaloneMode();
    return {
        showInstallMessage,
        isIos,
    };
}
